import { useEffect, useRef, useState } from 'react';

/**
 * @deprecated in favour of @tanstack/react-query for server state and controller-less hooks like createSharedState and useSharedState for UI state.
 */
export function useController<M, C>(initialModel: () => M, Controller: { new (_: (_: M) => void, m?: M): C & { dispose?(): void } }) {
  const [model, setModel] = useState<M>(initialModel);
  const [delegate, setDelegate] = useState<(C & { dispose?(): void }) | undefined>();
  // If the controller is already set and it doesn't need to be disposed, we can simply reuse it.
  // Mostly useful in strict mode during local dev, since useEffect runs twice there.
  const canReuseDelegate = useRef(false);

  useEffect(() => {
    if (canReuseDelegate.current) {
      return;
    }

    const localDelegate = new Controller(setModel, model);
    setDelegate(localDelegate);

    canReuseDelegate.current = !localDelegate.dispose;

    return () => localDelegate.dispose?.();

    // eslint thinks "canReuseDelegate.current" should be removed; it should not, as it causes constant re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Controller, setModel, setDelegate, canReuseDelegate.current]);

  return { model, delegate };
}
